(() => {
  'use strict';
  // Zelfde twee onafhankelijke afnemers als de zoeklade in custom-nav.js.
  const safe = (fn) => {
    try { return fn(); } catch (error) { return undefined; }
  };
  const emit = (event, fields = {}) => {
    const detail = { event, ...fields };
    safe(() => {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ ...detail });
      }
    });
    safe(() => document.dispatchEvent(new CustomEvent('eyk:nav', { detail: { ...detail } })));
  };
  // The menu owns the same five categories used by buildSearchTiles in custom-nav.js.
  const build = () => {
    document.querySelectorAll('[data-eyk-cart-empty]').forEach((empty) => {
      const categories = empty.querySelector('[data-eyk-empty-categories]');
      const row = empty.querySelector('.eyk-search-tiles__row');
      const fallback = empty.querySelector('[data-eyk-empty-shop-all]');
      if (!categories || !row) return;
      if (row.children.length) {
        categories.hidden = false;
        if (fallback) fallback.hidden = false;
        return;
      }
      const nav = document.querySelector('main-navigation');
      const items = nav ? [...nav.querySelectorAll('.navigation__tier-1 > .navigation__item')] : [];
      // Eerst exact, dan zonder spaties/hoofdletterverschil, dan de eerste promotiegroep.
      const shopAll = items.find((li) => {
          const a = li.querySelector(':scope > .navigation__link');
          return a && a.textContent.trim() === 'SHOP ALL';
        }) || items.find((li) => {
          const a = li.querySelector(':scope > .navigation__link');
          return a && a.textContent.replace(/\s+/g, '').toUpperCase() === 'SHOPALL';
        }) || items.find((li) => li.querySelectorAll('.menu-promotion').length >= 3);
      const promos = shopAll ? [...shopAll.querySelectorAll('.menu-promotion')] : [];
      promos.forEach((promo) => {
        const link = promo.querySelector('a');
        const img = promo.querySelector('img');
        const text = promo.querySelector('.menu-promotion__text');
        if (!link || !img) return;
        const src = img.getAttribute('data-eyk-src') || img.currentSrc || img.getAttribute('src') || '';
        const srcset = img.getAttribute('data-eyk-srcset') || img.getAttribute('srcset') || '';
        if (!src) return;
        const a = document.createElement('a');
        a.className = 'eyk-search-tiles__tile';
        a.href = link.getAttribute('href');
        const pic = document.createElement('img');
        pic.src = src;
        if (srcset) pic.srcset = srcset;
        pic.sizes = '(min-width: 768px) 72px, 20vw';
        pic.alt = img.getAttribute('alt') || '';
        pic.width = 544;
        pic.height = 1088;
        pic.loading = 'lazy';
        pic.decoding = 'async';
        a.appendChild(pic);
        const cap = document.createElement('span');
        cap.className = 'eyk-search-tiles__caption';
        cap.textContent = text ? text.textContent.trim() : (img.getAttribute('alt') || '');
        a.appendChild(cap);
        a.addEventListener('click', () => safe(() => emit('nav_click', { surface: 'cart-empty', group: 'Shop all', label: cap.textContent, kind: 'tile', href: a.getAttribute('href') })));
        row.appendChild(a);
      });
      categories.hidden = row.children.length === 0;
      // Altijd dezelfde winkelroute: CSS kiest tekstlink bij tegels, anders de knop.
      if (fallback) fallback.hidden = false;
    });
  };
  // A section script may be evaluated again by the editor; retain one set of listeners.
  if (window.eykCartEmptyBuild) {
    window.eykCartEmptyBuild();
    return;
  }
  window.eykCartEmptyBuild = build;
  document.addEventListener('DOMContentLoaded', build, {once: true});
  document.addEventListener('shopify:section:load', build);
  if (document.readyState !== 'loading') build();
})();
